<template>
  <div class="content viafree_req">
    <c회원선택 ref="selectCust" @select="selectCust" />

    <s-location apply title="면제증표 신청"/>

    <h4 class="sub_title02">면제증표 신청</h4>

    <table class="tbl01 t_kindsel">
      <tr>
        <th>면제사건 종류</th>
        <td class="al_l">
          <router-link to="viafree_req">
            <input type="radio" value="" name="freetype" id="rfree_1"/> <label for="rfree_1" v-cursor>일반면제</label>
          </router-link><br class="mobile"/>
<!-- 마스터인 경우 : 일반면제 & 복대리만 신청 가능 -->
          <router-link to="viafree_choffice"   class="via_kind" v-if="$store.state.session.user.type != 'master'">
            <input type="radio" value="" name="freetype" id="rfree_2"/> <label for="rfree_2" v-cursor>소속 변경으로 인한 면제</label>
          </router-link>
          <router-link to="viafree_bokdari" class="via_kind">
            <input type="radio" value="" name="freetype" id="rfree_3" checked="checked"/> <label for="rfree_3" v-cursor>복대리 면제</label>
          </router-link>
        </td>
      </tr>
    </table>

    <template v-if="$store.state.session.user.membstat != '개업'">
      <div class="comment_gray expcomment mt_15">
        <p class="tit">신청 권한이 없습니다.</p>
        <li>현재 <b>{{ $store.state.session.user.membstat }}</b> 상태이기 때문에 복대리 면제증표 신청을 하실 수 없습니다.</li>
      </div>
    </template>
    <template v-else>

      <div id="doViewChange"> <!-- 소속 변경으로 인한 면제 -->
        <!--  주의사항  -->
  <!--       <div class="comment_gray expcomment mtb30 gubun">
          <p class="tit"> 개인 > 법무법인 [개인사무실에서 법무법인(유한 포함)으로 이직한 경우]</p>
          <li>소송복대리 면제증표 신청은 최초 사건을 수임한 본대리인이 신청해야 합니다. </li>
        </div>
        -->
        <div class="btn_group">
          <div class="right">
            <button @click="initData" class="btn icon reload">초기화</button>
            <button @click="doSearch" class="btn icon search_black">검색</button>
          </div>
        </div>
        <!-- 검색조건 -->
        <table class="tbl01 sch_tbl">
          <tr>
            <th>사용일</th>
            <td>
              <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_viadtfr" :placeholder="search.iv_viadtfr"/>
            ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_viadtto" :placeholder="search.iv_viadtto"/>
            <br class="mobile"/>
              <s-date-range :fr.sync="search.iv_viadtfr" :to.sync="search.iv_viadtto" />
            </td>
          </tr>
  <!--         <tr>
            <th>증표 명의</th>
            <td><input type="text" class="sch_input" title="증표 명의" v-model="search.iv_membnm" placeholder="증표 명의" /> </td>
          </tr>
  -->
          <tr>
            <th>증표 종류</th>
            <td  class="radio_inline">
              <c증표종류_검색폼
                :search.sync="search"
                @select="doSearch"
                />
            </td>
          </tr>
          <tr>
            <th>증표 번호</th>
            <td>
                <input type="text" v-model="search.iv_rcptnofr_1" class="w_inputno" placeholder="증표번호 FROM" @keyup.enter="doSearch"/> -
                <input type="text" v-model="search.iv_rcptnoto_1" class="w_inputno" placeholder="증표번호 TO" @keyup.enter="doSearch"/>
            </td>
          </tr>
  <!--
          <tr>
            <th>위임인</th>
            <td>
                <input type="text" v-model="search.iv_client" class="sch_input" placeholder="위임인" />
            </td>
          </tr>
  -->
          <tr>
            <th>관할기관</th>
            <td>
                <input type="text" v-model="search.iv_isttoutplac" class="sch_input" placeholder="관할기관" @keyup.enter="doSearch"/>
            </td>
          </tr>
        <tr>
          <th>검색어</th>
          <td>
            <select v-model="search.iv_ktype">
              <option value="ALL"      >전체</option>
              <option value="MEMBNM"   >증표명의</option>
              <option value="CLIENT"   >위임인</option>
              <option value="OTHERSIDE">상대방</option>
              <option value="REMK"     >비고</option>
            </select>
            <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색어" @keyup.enter="doSearch"/>
          </td>
        </tr>
      </table>

      <!-- 수임사건 조회 -->
      <h4 class="sub_title02">검색 결과</h4>

        <!-- 테이블 -->
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>구입일자</th>
              <th class="viakind">증표종류</th>
              <th>증표번호</th>
              <th class="date">경유<br/>일자</th>
              <th>관할기관</th>
              <th>사건명</th>
              <th class="name">위임인</th>
              <th class="name">상대방</th>
              <th class="date">수임일자</th>
              <th class="viakind">사건<br/>유형</th>
              <th >사건번호</th>
              <th class="name" >담당변호사</th>
              <th class="no">비고</th>
              <th width="35px">추가</th>
            </tr>
          </thead>
          <tr v-for="(item,i) in list.items" :key=i :class="{ 'bg_gray01' : !showPlusBtn(item) }">
            <td>{{ ((list.pageNo -1) * list.listSize) + i +1 }}</td>
            <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
            <td>{{ item.org_caseclsfnm  }}</td>
            <td>{{ item.rcptno | insertHyphen(5) }}</td>
            <td>{{ item.viadt | moment('YYYY.MM.DD') }}</td>
            <td>{{ item.isttoutplac  }}</td>
            <td>{{ item.casenm  }}</td>
            <td>{{ item.client  }}</td>
            <td>{{ item.otherside  }}</td>
            <td>{{ item.cntchargdt | moment('YYYY.MM.DD') }}</td>
            <td>{{ item.casetypenm  }}</td>
            <td>{{ item.caseno  }}</td>
            <td>{{ item.membnms  }}</td>
            <td>{{ item.remk  }}</td>
            <td>
              <img v-if="showPlusBtn(item)"
                  src="/images/common/icon_plus_blue.png"
                  class="icon_squ"
                  @click="addRow(item)">
            </td>
          </tr>
        </table>
      </div> <!--// scroll_wrap -->

        <!-- //테이블 -->

        <!-- paging -->
        <div class="paging">
          <p class="num">
            <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
          </p>
        </div>
        <!-- /paging -->
      <!--           </form> -->

      <!-- 면제신청 할 사건 현황 -->
      <h4 class="sub_title02">복대리 면제신청할 사건 현황</h4>

        <!-- 테이블 -->
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>구입일자</th>
              <th class="viakind">증표종류</th>
              <th>증표번호</th>
              <th>경유<br/>일자</th>
              <th>관할기관</th>
              <th>사건명</th>
              <th class="name">위임인</th>
              <th class="name">상대방</th>
              <th class="td_org01 line_l">수임일자</th>
              <th class=" viakind">사건<br/>유형</th>
              <th>사건번호</th>
              <th>담당변호사</th>
              <th>비고</th>
              <th width="35px">제거</th>
            </tr>
          </thead>

            <tr v-for="(item,i) in saveList" :key=i>
              <td>{{ i + 1 }}</td>
              <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
              <td>{{ item.org_caseclsfnm  }}</td>
              <td>{{ item.rcptno | insertHyphen(5) }}</td>
              <td>{{ item.viadt | moment('YYYY.MM.DD') }}</td>
              <td>{{ item.isttoutplac  }}</td>
              <td>{{ item.casenm  }}</td>
              <td>{{ item.client  }}</td>
              <td>{{ item.otherside  }}</td>
              <td>{{ item.cntchargdt | moment('YYYY.MM.DD') }}</td>
              <td>{{ item.casetypenm  }}</td>
              <td>{{ item.caseno  }}</td>
              <td>{{ item.membnms  }}</td>
              <td>{{ item.remk  }}</td>
              <td class="p0">
                <img src="/images/common/icon_minus_org.png"
                    class="icon_squ"
                    @click="delRow(item)">
              </td>
            </tr>
        </table>
      </div> <!--// scroll_wrap -->

      </div> <!-- // #doViewChange -->

      <br/>
      <div>

      <h4 class="sub_title02">복대리 수임변호사 입력</h4>

      <table class="tbl01 sum">
        <tr>
          <th>수임 변호사</th>
          <td>
            <input type="text" v-model="sitem.to_membnm" ref="to_membnm" class="w_nm" @keydown.enter="$refs.selectCust.open('P',sitem.to_membnm, '', 'Y')" @keydown="initCust">
            <template v-if="sitem.to_guestyn == 'Y'"> (타회소속) </template>
            {{ clsfToText(sitem.to_membclsf) }} - {{ sitem.to_membno }}
            <button @click="$refs.selectCust.open('P',sitem.to_membnm, '', 'Y')" class="btn xs org01">회원선택</button>
          </td>
        </tr>
        <tr>
          <th>비고</th>
          <td><input type="text" class="w50p" v-model="sitem.reasonremk" /></td>
        </tr>
      </table>
      </div>

      <div class="btn_group ">
        <button @click="saveItem" class="btn gray01 right">신청</button>
      </div>
    </template>
  </div> <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
   components: {
    'c증표종류_검색폼'   : require('@/components/c증표종류_검색폼.vue').default,
    "c회원선택"          : require('@/components/c회원선택.vue').default,
   },
   data () {
    return {
      search : {},
      search_init : {
        iv_menu         : 'bokdari'
      , iv_viadtfr      : this.$moment().add(-1, 'month').format("YYYY-MM-DD")
      , iv_viadtto      : this.$moment().format("YYYY-MM-DD")
      , iv_statclsf     : "BC0200"     // 사용건만 출력
      , iv_viaplac      : ""
      , iv_caseclsf     : ""
      , iv_rcptnofr_1   : ""
      , iv_rcptnoto_1   : ""
      , iv_rcptnofr     : ""
      , iv_rcptnoto     : ""
      , iv_cntchargdtfr : ""
      , iv_cntchargdtto : ""
      , iv_client       : ""
      , iv_isttoutplac  : ""
      , iv_otherside    : ""
      , iv_linkyn       : ""
      , iv_lostyn       : ""
      , iv_onlineyn     : ""
      , iv_lawyernm     : ""
      , iv_membclsf     : ""
      , iv_membno       : ""
      , iv_membnm       : ""
      , iv_viamembclsf  : ""
      , iv_viamembno    : ""
      , iv_officeclsf   : ""
      , iv_officeno     : ""
      , iv_selldtfr     : ""
      , iv_selldtto     : ""
      , iv_order_by1    : ""
      , iv_order_by2    : ""
      , iv_order_by3    : ""
      , iv_order_by4    : ""
      , iv_freeclsf     : ""
      , iv_case_b10300  : ""
      , iv_ktype        : "ALL"
      , iv_kword        : ""
      , iv_cancelclsf   : ""
      , iv_searchdtgbn  : ""
      , iv_searchfr     : ""
      , iv_searchto     : ""
      },
      sitem : {
        reasonclsf : '',
        reasonremk : '',
        to_guestyn : '',
        to_membclsf : '',
        to_membno : '',
        to_membnm : '',
      },
      code: {},
      chkAll : false,
      list: {
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      saveList : [],
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    // T.attrClearSet(this.search, '', this.search_init)
    // T.attrClear(this.sitem , '')
    this.search = { ...this.search_init }
    this.sitem  = { ...this.sitem_init }
  },
  mounted() {
     // 공통코드 로드
    ui.codeLoad("RCH_OFFICE", code => {
      this.code = code
      this.doSearch()
    });
  },
  methods : {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.sitem  = T.deepCopy(this.sitem_init)
      // T.attrClearSet(this.search, '', this.search_init)
      // T.attrClear(this.sitem , '')
      this.saveList = []


      this.doSearch()
    },
    addRow(item) {
      if (this.saveList.filter(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq).length > 0) {
        return ui.alert("이미 선택된 사건입니다. 선택 리스트를 확인해 주세요.")
      }

      this.saveList.push(item)
    },
    delRow(item) {
      this.saveList = this.saveList.filter(e => !(e.viaregdt == item.viaregdt && e.viaseq == item.viaseq))
    },
    showPlusBtn(item) {
      return !this.saveList.some(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq)
    },
    doSearch() {
      this.search.iv_rcptnofr = this.search.iv_rcptnofr_1 + "" + this.search.iv_rcptnoto_1
      this.search.iv_rcptnoto = this.search.iv_rcptnofr

      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])

        })
    },
    saveItem() {
      if (this.saveList.length == 0) {
        return ui.alert("면제신청할 사건을 추가해 주세요.")
      }

      ui.confirm('신청하시겠습니까 ?', "신청확인")
        .then(r => r && this.itemUpdate())
    },
    itemUpdate() {
      this.saveList.some((item, i) => {
        this.sitem.viaregdt = ((i == 0) ? '' : this.sitem.viaregdt + '#') + item.viaregdt
        this.sitem.viaseq   = ((i == 0) ? '' : this.sitem.viaseq   + '#') + item.viaseq
      })

      ui.httpPost("/proc_iv/N_VIASTAT_UPD",
      {
        ...this.sitem
        , viastatclsf  : 'BOKDARI'
        , approveclsf  : 'REQ'
        , reasonclsf   : 'ETC' // 신청사유 종류는 기타로 고정해야, 신청사유(=비고) 입력한 것이 저장됨.
        , approvemsg   : ''
        , viastatdt    : ''
        , viastatseq   : ''
        , viastatdtlid : ''
        , caseclsf     : ''
        , to_caseclsf  : ''
        , to_casetype  : ''
        , to_viafee    : 0
        , to_amt       : 0
        , rf_amt       : 0
        , rfway        : ''
        , rfbankcode   : ''
        , remk         : ''
        , rfaccno      : ''
        , rfaccname    : ''
        , attachid     : '' // 첨부파일 ID
        , attachid2    : '' // 첨부파일 ID2
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때 신청내역 페이지로 이동
           this.$router.push({ path: 'stat_list' })
        }

      })
    },
    selectCust(item) {
      this.sitem.to_guestyn  = T.defaultEmpty(item.guestyn, 'N')
      this.sitem.to_birthday = item.birthday
      this.sitem.to_membclsf = item.membclsf
      this.sitem.to_membno   = item.membno
      this.sitem.to_membnm   = item.membnm
      // console.log("수입변호사로 선택한 회원 : " + JSON.stringify(this.sitem));
    },
    initCust() {
      T.attrClear(this.sitem)
    },
    clsfToText(v) {
      switch(v) {
        case 'P' : return "개인"
        case 'B' :
        case 'C' : return "법인"
        case 'J' : return "공동"
        case 'D' : return "공동"
      }
      return v
    },
  }
}
</script>
<style scoped>
  .via_kind { margin-left:50px;}
  .comment_gray li { background:none; padding-left:0}

  .gubun .tit { margin: 0; }
  .gubun .tit:nth-child(n+2) { margin-top: 25px; } /* 두번째 .tit 부터 탑 마진 적용 */

  @media screen and (max-width:640px){
    .via_kind { margin-left:0px;}
    .comment_gray { padding:15px;}

    .t_kindsel th{ width:auto; }
    .t_kindsel td{line-height: 2.0;}
    .tbl01.sum input, .tbl01.sum select {  width:50%;}

  }
</style>